import Button from '../components/button/Button';
// import React, { useState, useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import classes from './home.module.css'
import { Link } from 'react-router-dom';
import { ParallaxProvider, Parallax } from 'react-scroll-parallax';



export default function Home() {
    const { ref: classic, inView } = useInView({ delay: 100 })
    const { ref: giant, inView: giantView } = useInView({ delay: 100 })

    return (
        <>
            <ParallaxProvider>
                <section className={classes.page} >
                    <div className={classes.bgFloor}>
                        <img className={classes.img} src="./img/pisoalta200.jpg" alt="Fondo de piso" />

                    </div>
                    <div className={classes.container}>
                        <div className={classes.container2}>
                            <div className={`${classes.titleCont} ${classes.paddingFromBtn}`}>
                                <div className={classes.title}>
                                    <h1 className={classes.titleAnimation}>
                                        Select
                                    </h1>
                                </div>
                                <div className={classes.title}>
                                    <h1 className={classes.titleAnimation}>
                                        flooring
                                    </h1>
                                </div>
                                <div className={classes.title}>
                                    <h3>
                                        maximum resistance
                                    </h3>
                                </div>
                            </div>
                            <Button text={'+info'} link={'/selectFlooring'} />

                            <Link to='#'><img className={classes.icon} src="./img/icon-flecha.png" alt='icono flecha' /></Link>
                        </div>

                    </div>
                </section>
                <section className={classes.secP} id="#clasicFlooring">
                    <div className={classes.container}>
                        <Parallax speed={5}>
                            <div className={classes.paralaxContainer}>
                                <img className={classes.imgCF} src="./img/foto3.jpg" alt="" />

                            </div>
                        </Parallax>

                        {/* <img className={classes.imgClassic} src="./img/FOTO3.jpg" alt="Imagen Classic Flooring" /> */}
                        <Parallax speed={5}>
                            <div className={classes.infoClasic}>
                                <div ref={classic} className={classes.title}>
                                    <h2 className={`${inView ? `${classes.titleAnimation} ${classes.titleTextItalic}` : `${classes.titleTextItalic}`}`} >
                                        Classic
                                    </h2>
                                </div>
                                <div className={classes.title}>
                                    <h2 className={`${inView ? `${classes.titleAnimation} ${classes.titleText}` : `${classes.titleTextItalic}`}`}>
                                        <span> Flooring</span>
                                    </h2>
                                </div>

                                <p className={classes.paddingFromBtn}>Make it your own <br /> Make it your home</p>
                                <Button text={'+info'} link={'/classicFlooring'} />
                            </div>
                        </Parallax>
                    </div>
                </section>
                <section className={classes.wall}>
                    <div className={classes.giantWall}>
                        <div className={classes.gWallInfo}>
                            <h3>
                                Big size, <br /> "Single Piece" effect
                            </h3>
                            <div>
                                <div ref={giant} className={classes.title}>
                                    <h2 className={`${giantView ? `${classes.titleAnimation} ${classes.titleTextItalic} ${classes.blackFont}` : `${classes.titleTextItalic}`}`} >
                                        Giant Wall
                                    </h2>
                                </div>
                                <div className={classes.title}>
                                    <h2 className={`${giantView ? `${classes.titleAnimation} ${classes.titleText} ${classes.paddingFromBtn} ${classes.blackFont}` : `${classes.titleTextItalic}`}`}>
                                        <span className={classes.paddingFromBtn}> Panels</span>
                                    </h2>
                                </div>
                                <Button className={classes.btn} text={'+info'} link={'/giantWallPanels'} />
                            </div>
                        </div>
                        <img className={classes.gWallPic} src="/img/FOTO n 6 Giant Wall Panels 1920 x 1080.jpg" alt="" />
                    </div>
                </section>
            </ParallaxProvider>
        </>
    )
}
